import { tokenizeCard } from '@reverbdotcom/discovery-ui';
import { adyenTokenizationParams } from '../adyen_ujs';

const verifyLinkSelector = '[data-verify-card-submit]';
const creditCardRadioSelector = 'input[name=\'payment[credit_card_id]\']';
const submitFormButtonSelector = 'form[data-adyen-classic-card-form] input[type=submit]';
const visibleCardVerificationSelector = '[data-credit-card-id] [data-verify-card-container]:visible';

const adyenInputSelector = '[data-adyen-name]';
const allTokenizedInputsSelector = adyenInputSelector;
const verifyCardInputsSelector = `[data-verify-card-container] ${adyenInputSelector}`;
const newCardInputsSelector = `[data-new-credit-card-fields] ${adyenInputSelector}`;

function verifyContainerForCreditCard(creditCardId) {
  return $(`[data-credit-card-id=${creditCardId}] [data-verify-card-container]`);
}

function cvvInputForCreditCard(creditCardId) {
  return $(`[data-credit-card-id=${creditCardId}] [data-adyen-name=cvc]`);
}

function needsVerification(creditCardId) {
  return verifyContainerForCreditCard(creditCardId).length > 0;
}

function showVerificationError(creditCardId) {
  $(`[data-credit-card-id=${creditCardId}] [data-verify-card-alert]`).show();
}

function findCreditCardId(event) {
  return $(event.target).closest('[data-credit-card-id]').data('credit-card-id');
}

function enable(selector) {
  $(selector).prop('disabled', false);
}

function disable(selector) {
  $(selector).prop('disabled', true);
}

function hideVisibleCardVerification() {
  $(visibleCardVerificationSelector).slideUp();
}

function showSelectedCard(creditCardId) {
  verifyContainerForCreditCard(creditCardId).slideDown();
}

function allowPaymentWithSelectedCard() {
  hideVisibleCardVerification();
  disable(allTokenizedInputsSelector);
  enable(submitFormButtonSelector);
}

function handleVerificationSuccess(creditCardId) {
  const verifyContainer = verifyContainerForCreditCard(creditCardId);
  verifyContainer.stopSpinner().slideUp(() => verifyContainer.remove());
  allowPaymentWithSelectedCard();
}

function handleVerificationError(creditCardId) {
  verifyContainerForCreditCard(creditCardId).stopSpinner();
  showVerificationError(creditCardId);
}

function verifyCreditCard(creditCardId, tokenParams) {
  $.ajax({
    type: 'POST',
    url: `/my/credit_cards/${creditCardId}/reverify`,
    data: tokenParams,
  }).then(() => handleVerificationSuccess(creditCardId))
    .fail(() => handleVerificationError(creditCardId));
}

function reverifyAdyenCard(creditCardId) {
  const form = $('[data-credit-card-id]').closest('form');

  return verifyCreditCard(creditCardId, {
    adyen_token: tokenizeCard(adyenTokenizationParams(form)),
  });
}

function handleVerifyButtonClick(event) {
  event.preventDefault();
  const creditCardId = findCreditCardId(event);

  verifyContainerForCreditCard(creditCardId).spin();

  reverifyAdyenCard(creditCardId);
}

function showNewCreditCardFields() {
  hideVisibleCardVerification();
  enable(submitFormButtonSelector);
  enable(newCardInputsSelector);
  disable(verifyCardInputsSelector);
}

function requireCardVerification(creditCardId) {
  hideVisibleCardVerification();
  disable(allTokenizedInputsSelector);
  showSelectedCard(creditCardId);
  enable(cvvInputForCreditCard(creditCardId));
  disable(submitFormButtonSelector);
}

function selectCreditCard(creditCardId) {
  if (creditCardId === '' || creditCardId === undefined) {
    showNewCreditCardFields();
  } else if (needsVerification(creditCardId)) {
    requireCardVerification(creditCardId);
  } else {
    allowPaymentWithSelectedCard();
  }
}

function handleCreditCardSelectionChange(event) {
  selectCreditCard(findCreditCardId(event));
}

function init() {
  $(creditCardRadioSelector).on('change', handleCreditCardSelectionChange);
  $(verifyLinkSelector).on('click', handleVerifyButtonClick);

  const selectedCreditCardId = $(`${creditCardRadioSelector}:checked`).val();
  selectCreditCard(selectedCreditCardId);
}

$(init);

export default {
  init,
};



// WEBPACK FOOTER //
// ./javascripts/components/bundled_checkout/reverify_credit_card.js